import { render } from "./StyleGuide.vue?vue&type=template&id=6751e240"
import script from "./StyleGuide.vue?vue&type=script&lang=ts"
export * from "./StyleGuide.vue?vue&type=script&lang=ts"

import "./StyleGuide.vue?vue&type=style&index=0&id=6751e240&lang=scss"
script.render = render

export default script